import { Link } from "react-router-dom";
import ToolbarToggles from "@/components/ToolbarToggles";

/**
 * PageShell - consistent corporate toolbar + content wrapper.
 *
 * Renders a sticky top toolbar with breadcrumb (Workspace / Section / Page · context)
 * then the page content below. Used across all pages except the Dashboard
 * (which has its own period-selector toolbar).
 */
export default function PageShell({
  section,
  page,
  context,
  actions,
  testid,
  toolbarExtra,
  children,
}) {
  return (
    <div className="flex flex-col min-h-screen">
      <header
        className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 px-3 sm:px-4 lg:px-8 py-3 flex items-center justify-between gap-2 sm:gap-4 flex-wrap sticky top-0 z-30 transition-colors"
        data-testid={testid || "page-toolbar"}
      >
        <div className="flex items-center gap-1.5 sm:gap-3 text-xs min-w-0 flex-1">
          <Link to="/" className="hidden sm:inline text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors">Workspace</Link>
          <span className="hidden sm:inline text-slate-300 dark:text-slate-600">/</span>
          {section && (
            <>
              <span className="hidden sm:inline text-slate-500 dark:text-slate-400">{section}</span>
              <span className="hidden sm:inline text-slate-300 dark:text-slate-600">/</span>
            </>
          )}
          <span className="text-slate-900 dark:text-white font-medium truncate">{page}</span>
          {context && (
            <>
              <span className="hidden sm:inline text-slate-300 dark:text-slate-600">·</span>
              <span className="hidden md:inline text-slate-500 dark:text-slate-400 truncate">{context}</span>
            </>
          )}
        </div>
        <div className="flex items-center gap-2 sm:gap-3 flex-wrap justify-end">
          {toolbarExtra}
          {actions}
          <ToolbarToggles />
        </div>
      </header>

      <div className="flex-1 p-3 sm:p-4 md:p-6 lg:p-8 max-w-[1600px] w-full mx-auto">
        {children}
      </div>
    </div>
  );
}
